import { useEffect } from 'react'

import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'

export default function useSetDefaultValueOnNotArrayData({ formMethods, question }: DefaultValueCommonProps) {
  useEffect(() => {
    const currentValue = question.default_value

    if (Array.isArray(currentValue)) {
      formMethods.setValue('default_value', currentValue[0] ?? '')
    }
  }, [question.default_value])

  return null
}
